<!-- Button trigger modal -->
<div class="bg-wrapper pt-2">
    <header class="mb-2 container">
        <div>
            <a href="#" class="brand"
                ><img src="../assets/images/jsw-logo.png" alt="jsw-logo"
            /></a>
        </div>
    </header>

    <main class="password-change container justify-content-center py-5">
        <div class="row">
            <div class="col-md-5 offset-md-4">
                <div class="language-pane">
                    <h3 class="mb-4">Change Password</h3>
                    <p class="mb-4">Create a new login password.</p>
                    <form
                        [formGroup]="passwordData"
                        (ngSubmit)="mandatoryPasswordChange()"
                    >
                        <p *ngIf="isError" class="help-block">
                            <span><i class="ri-error-warning-fill"></i></span>
                            Sorry, Your password couldn't be changed. Please try
                            again
                        </p>
                        <div class="mb-4">
                            <label class="form-label">New Password</label>
                            <p
                                class="help-block"
                                *ngIf="
                  passwordData.get('newPassword')?.errors?.['required'] &&
                  passwordData.get('newPassword')?.touched
                "
                            >
                                New Password is requried
                            </p>
                            <p
                                class="help-block"
                                *ngIf="
                  passwordData.get('newPassword')?.errors?.['pattern'] &&
                  passwordData.get('newPassword')?.touched
                "
                            >
                                Password must contain a symbol and special
                                character
                            </p>
                            <p
                                class="help-block"
                                *ngIf="
                passwordData.get('newPassword')?.errors?.['maxlength'] &&
                passwordData.get('newPassword')?.touched
              "
                            >
                                Password must not exceed 15 characters
                            </p>
                            <p
                                class="help-block"
                                *ngIf="
              passwordData.get('newPassword')?.errors?.['minlength'] &&
              passwordData.get('newPassword')?.touched
            "
                            >
                                Password must be at least 8 characters
                            </p>
                            <input
                                type="password"
                                class="form-control"
                                id="new_password"
                                placeholder="xxxxxxxxxxx"
                                formControlName="newPassword"
                            />
                        </div>
                        <div class="mb-4">
                            <label class="form-label"
                                >Confirm New Password</label
                            >
                            <p
                                class="help-block"
                                *ngIf="
                passwordData.get('confirmPassword')?.errors?.['required'] &&
                passwordData.get('confirmPassword')?.touched"
                            >
                                The Password does not match
                            </p>
                            <p
                                class="help-block"
                                *ngIf="
                passwordData.get('confirmPassword')?.errors?.['matching'] &&
                passwordData.get('confirmPassword')?.touched"
                            >
                                The password does not match
                            </p>
                            <input
                                type="password"
                                class="form-control"
                                id="confirm_new_password"
                                placeholder="xxxxxxxxxxx"
                                formControlName="confirmPassword"
                            />
                        </div>
                        <button
                            [disabled]="passwordData.invalid"
                            type="submit"
                            class="btn btn-primary"
                        >
                            Set Password
                        </button>
                        <div class="loader text-center mt-3" *ngIf="isLoading">
                            Loading ...
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </main>

    <footer class="mt-auto d-flex justify-content-center">
        <p>
            Powered by
            <a href="javascript:void(0)" class="brand-payex"
                ><img src="assets/images/payex-logo.png" alt="PayExLogo"
            /></a>
        </p>
    </footer>
</div>
